import { type ReactNode } from "react";

import { Dialog, Portal, Text } from "@chakra-ui/react";

import { Button } from "@shared/ui/chakra/buttons/button";

type Props = {
  cancelLabel: ReactNode;
  confirmLabel: ReactNode;
  description: ReactNode;
  title: ReactNode;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const PasswordExpiredDialog = ({
  cancelLabel,
  confirmLabel,
  description,
  title,
  isOpen,
  onCancel,
  onConfirm,
}: Props) => {
  return (
    <Dialog.Root
      open={isOpen}
      placement="center"
      onOpenChange={(e) => {
        if (!e.open) {
          onCancel();
        }
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>{title}</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Text>{description}</Text>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline" onClick={onCancel}>
                  {cancelLabel}
                </Button>
              </Dialog.ActionTrigger>
              <Button onClick={onConfirm}>{confirmLabel}</Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
